var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('span',{class:_vm.textcolor},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"highlighted"},[_vm._v(_vm._s(_vm.highlighted))]),_c('p',{class:_vm.textcolor},[_vm._v(_vm._s(_vm.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }